import { Injectable, Signal } from '@angular/core';
import { AbstractDialogService, DialogOptions } from '@examdojo/core/dialog';
import { FilterSectionData, SingleFilterData } from './filter-section.directive';
import { FiltersPanelMobileContentComponent } from './filters-panel-mobile-content.component';

export interface FiltersPanelDialogInput {
  titleLabel: string;
  filters: FilterSectionData[];
  isSelected?: boolean | Signal<boolean>;
  clearAllLabelKey?: string;
  clearAllFn?: () => void;
}

@Injectable()
export class FiltersPanelDialogService extends AbstractDialogService<
  FiltersPanelDialogInput,
  void,
  typeof FiltersPanelMobileContentComponent
> {
  readonly id = 'filters-panel-dialog';
  protected readonly component = FiltersPanelMobileContentComponent;

  protected override readonly dismissOnBreakpointChange = true;

  open(input: FiltersPanelDialogInput) {
    return super.openDialog({
      options: {
        cssClass: 'action-sheet-on-mobile auto-height',
        componentProps: {
          titleLabel: input.titleLabel,
          filters: input.filters,
          isSelectedInput: input.isSelected,
          clearAllLabelKey: input.clearAllLabelKey ?? 'examdojo.clear_all',
          onClearAllFn: input.clearAllFn,
        },
      } satisfies DialogOptions,
    });
  }

  openSingleFilter(filter: SingleFilterData) {
    const filterWithName: FilterSectionData = { ...filter, name: filter.label };

    return this.open({
      titleLabel: filter.label,
      filters: [filterWithName],
      isSelected: filter.isSelected,
      clearAllLabelKey: 'examdojo.clear',
      clearAllFn: filter.clearFn,
    });
  }
}
